import ThreeColumnImageSimpleRepository from "../ThreeColumnImageSimpleRepository"

export default class DemoThreeColumnImageSimple extends ThreeColumnImageSimpleRepository {
    static schemaId = "demo_threeColumnImage"

    constructor() {
        super(DemoThreeColumnImageSimple.schemaId)
    }
}
